import { useState, useEffect, useContext } from "react";
import ModalNotificaciones from "./Modal";
import { Row, Col, Drawer, Button } from "antd";
import "./Navbar.style.scss";
import { useNavigate } from "react-router-dom";
import { TemplateContext } from "../../../utils/template_context";
import { CMenu } from "../../layout/LayoutMenu/layout.view";
import bars from './bars.svg';
import bell from './bell.svg';
import getStorageUser from "../../../middlewares/GetStorageUser"
import { ObjNotificaciones } from "../../../config/notificaciones";


export const Navbar = () => {
  const context = useContext(TemplateContext);
  const [user, setUser] = useState<any>({});
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [cantidadNotificaciones] = useState(0);
  const navigate = useNavigate();
  const nombreCompleto = user != undefined ? `${user.nombres} ${user.apellidos}` : "";

  const getUser = async () => {
    try {
      const user = getStorageUser()
      setUser(user);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
    const user = getStorageUser()
    if (!user) {
      ObjNotificaciones.MSG_ERROR('error', 'Acceso denegado', 'No tienes acceso a esta ruta');
      return navigate('/login')
    }
  }, []);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const [drawerVisible, setDrawerVisible] = useState(false);

  const openDrawer = () => setDrawerVisible(true);

  const onClose = () => {
    setDrawerVisible(false);
  };

  return (
    <Row
      className="width-100 background-color-FFFFFF size-navbar-admin"
      justify="end"
    >
      <Col
        className="font-size-14px font-family-Montserrat-Regular d-none d-md-block"
        style={{ display: "flex", marginLeft: "20px" }}
      >
        <span>Secretaría de cultura ciudadana, Fomento a la cultura</span>
      </Col>
      <div className="flex-fill " />
      <Col
        className="font-size-11px font-family-Montserrat-Regular"
        style={{ display: "flex" }}
      >
        Hola,{" "}<span className="font-family-Monserrat-Bold" style={{ marginLeft: '5px' }}> {nombreCompleto}</span>
      </Col>
      <Col
        onClick={async () => {
          showModal();
        }}
        style={{ display: "flex", cursor: "pointer", marginLeft: '10px' }}
      >
        <img src={bell} alt="" />
        <div
          className="font-size-11px text-center font-color-FF8900 container-div-number-notification"
          style={{ marginLeft: "2px" }}
        >
          {cantidadNotificaciones}+
        </div>
      </Col>
      <Col
        className="font-size-11px"
        style={{ marginLeft: "10px", marginRight: "36px", cursor: "pointer", color: 'red' }}
        onClick={openDrawer}
      >
        <img src={bars} alt="" />
      </Col>
      <ModalNotificaciones
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
      />
      <Drawer
        width={300}
        placement="right"
        onClose={onClose}
        visible={drawerVisible}
        footer={
          <>
            <Row justify="center">
              <Button
                className="button-mora-ghost boton-cerrar"
                onClick={() => {
                  navigate("/cambiarcontrasena");
                }}
              >
                CAMBIAR CONTRASEÑA
              </Button>
            </Row>
            <Row justify="center">
              <Button
                className="button-rojo-ghost boton-cerrar"
                onClick={() => {
                  localStorage.removeItem("token");
                  localStorage.removeItem("user");
                  localStorage.clear();
                  window.location.replace('https://www.medellin.gov.co/estimuloscultura/');
                }}
              >
                CERRAR SESIÓN
              </Button>
            </Row>
          </>
        }
      >
        <div
          style={{ display: "flex", flexDirection: "column", height: "100%" }}
        >
          <Row className="drawer-header">
            <Col className="drawer_names">
              <span className="names">{user?.nombres}</span>
              <span className="lastnames">{user?.apellidos}</span>
            </Col>
            <Col>
              <span className="cc">C.C {user?.documento}</span>
            </Col>
          </Row>
          {(context.device === "md" || context.device === 'sm') && <CMenu />}
        </div>
      </Drawer>
    </Row>
  );
};
